import React from 'react'

const DownloadIcon = props => (
  <svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity="0.75">
      <path
        d="M1.3 10.4499H11.7C12.1142 10.4499 12.45 10.7857 12.45 11.1999C12.45 11.6141 12.1142 11.9499 11.7 11.9499H1.3C0.885787 11.9499 0.55 11.6141 0.55 11.1999C0.55 10.7857 0.885787 10.4499 1.3 10.4499Z"
        fill="currentColor"
        stroke="#326EB2"
        strokeWidth="0.1"
      />
      <path
        d="M3.11827 6.19099L3.11827 6.19099C2.80512 5.87867 2.80504 5.37245 3.11824 5.06009C3.43145 4.74771 3.93903 4.74745 4.25253 5.06012L5.60492 6.40943L5.69024 6.49455V6.37403V0.915914C5.69024 0.474586 6.04905 0.116564 6.49222 0.116564C6.93527 0.116564 7.29419 0.47489 7.29419 0.915914L7.29419 6.38956V6.51008L7.37951 6.42496L8.74747 5.06012C9.0607 4.74773 9.56849 4.74765 9.88177 5.06009C10.1949 5.37239 10.1952 5.87839 9.88173 6.19099L9.91704 6.22639L9.88173 6.19099L6.86672 9.19844C6.6643 9.40034 6.3358 9.40044 6.13329 9.19844L3.11827 6.19099Z"
        fill="currentColor"
        stroke="#326EB2"
        strokeWidth="0.1"
      />
    </g>
  </svg>
)

export default DownloadIcon
